import { gql } from "@apollo/client";

export const GET_CONTACT_US = gql`
query ContactUs {
    contactUs {
        id
        value
    }
}
`;